import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row q-pa-md border-bottom" }
const _hoisted_2 = { class: "col-6 text-body2" }
const _hoisted_3 = {
  key: 1,
  class: "row q-pa-md border-bottom"
}
const _hoisted_4 = { class: "col-6 text-body2" }
const _hoisted_5 = { class: "row q-pa-md border-bottom" }
const _hoisted_6 = {
  key: 0,
  class: "col-6 text-body2"
}
const _hoisted_7 = { class: "row q-pa-md border-bottom" }
const _hoisted_8 = { class: "col-6 text-body2" }
const _hoisted_9 = { class: "row q-pa-md border-bottom" }
const _hoisted_10 = { class: "col-6 text-body2" }
const _hoisted_11 = {
  key: 2,
  class: "row q-pa-md border-bottom"
}
const _hoisted_12 = { class: "col-6 text-body2" }
const _hoisted_13 = {
  key: 3,
  class: "row q-pa-md border-bottom"
}
const _hoisted_14 = { class: "col-6 text-body2" }
const _hoisted_15 = {
  key: 5,
  class: "q-pa-md text-overline brand-app-bg brand-border border-bottom"
}

import { PropType, computed, ref, onMounted } from "vue";
  import { HpPrice, LoanApplication, PcpPrice, Vehicle } from "src/types/loan-application/index";
  import { StockFilter } from "src/types/vehicle-search/index";
  import StockDetailsFinance from "./StockDetailsFinance.vue";
  import { useCurrencyFormatter } from "src/functions";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'StockDetails',
  props: {
    vehicle: {
      type: Object as PropType<Vehicle>,
      default: null
    },
    pcp: {
      type: Object as PropType<PcpPrice | null>,
      default: null
    },
    hp: {
      type: Object as PropType<HpPrice | null>,
      default: null
    },
    filters: {
      type: Object as PropType<StockFilter>,
      default: null
    },
    selectedProduct: {
      type: String,
      default: "hp"
    },
    noPictures: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'create', 'createQQ'],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const product = ref<string>(props.selectedProduct);
  const show = ref(false);

  onMounted(() => {
    setTimeout(() => {
      show.value = true
      if (props.selectedProduct === '') {
        document.getElementById("vehicleDetails")!.scrollIntoView({ block: "end" });
        product.value = 'hp'
      }
      else {
        document.getElementById("quoteDetails")!.scrollIntoView({ block: "start" });
        product.value = props.selectedProduct
      }
    }, 100)
  })

  const imgIndex = ref(0);

  const emit = __emit
  function close() {
    emit('close');
  }
  function create() {
    emit('create');
  }
  function createQQ() {
    emit('createQQ');
  }

  __expose({ getSelectedQuote });
  function getSelectedQuote() {
    if (product.value == "pcp")
    {
      return props.pcp;
    }
    return props.hp;
  }

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_carousel = _resolveComponent("q-carousel")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[10] || (_cache[10] = _createElementVNode("div", {
      id: "vehicleDetails",
      class: "q-pa-md brand-app-bg border-top border-bottom brand-border text-overline"
    }, "Vehicle Details", -1)),
    (!__props.noPictures)
      ? (_openBlock(), _createBlock(_component_q_carousel, {
          key: 0,
          modelValue: imgIndex.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((imgIndex).value = $event)),
          "transition-prev": "slide-right",
          "transition-next": "slide-left",
          animated: "",
          arrows: "",
          "control-color": "primary",
          class: "rounded-borders"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.vehicle.images, (img, index) => {
              return (_openBlock(), _createBlock(_component_q_carousel_slide, {
                key: 'vs'+index,
                name: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_img, {
                    src: img,
                    class: "full-height",
                    fit: "contain"
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Make & Model ", -1)),
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.vehicle.make) + " " + _toDisplayString(__props.vehicle.model), 1)
    ]),
    (__props.vehicle.trim)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Trim ", -1)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(__props.vehicle.trim), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Year ", -1)),
      (__props.vehicle.vehicleDateOfFirstReg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(new Date(__props.vehicle.vehicleDateOfFirstReg).getFullYear()), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " VRM ", -1)),
      _createElementVNode("div", _hoisted_8, _toDisplayString(__props.vehicle.vehicleRegistration), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Mileage ", -1)),
      _createElementVNode("div", _hoisted_10, _toDisplayString(__props.vehicle.mileage.toLocaleString()) + " miles ", 1)
    ]),
    (!__props.noPictures)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Transmission ", -1)),
          _createElementVNode("div", _hoisted_12, _toDisplayString(__props.vehicle.transmission), 1)
        ]))
      : _createCommentVNode("", true),
    (!__props.noPictures)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Fuel Type ", -1)),
          _createElementVNode("div", _hoisted_14, _toDisplayString(__props.vehicle.fuel), 1)
        ]))
      : _createCommentVNode("", true),
    (!__props.vehicle.cannotPrice)
      ? (_openBlock(), _createBlock(_component_q_tabs, {
          key: 4,
          modelValue: product.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((product).value = $event)),
          id: "quoteDetails",
          align: "justify",
          "no-caps": "",
          "indicator-color": "primary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tab, {
              name: "pcp",
              disable: !__props.pcp
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(product.value==='pcp' ? 'text-subtitle2': 'text-body2')
                }, "PCP " + _toDisplayString(!__props.pcp ? 'Unavailable' : ''), 3)
              ]),
              _: 1
            }, 8, ["disable"]),
            _createVNode(_component_q_tab, { name: "hp" }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(product.value==='hp' ? 'text-subtitle2': 'text-body2')
                }, "HP", 2)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (!__props.vehicle.cannotPrice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Finance Breakdown "))
      : _createCommentVNode("", true),
    (!__props.vehicle.cannotPrice)
      ? (_openBlock(), _createBlock(_component_q_tab_panels, {
          key: 6,
          modelValue: product.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((product).value = $event)),
          animated: "",
          "transition-prev": "fade",
          "transition-next": "fade"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tab_panel, {
              name: "pcp",
              class: "q-pa-none"
            }, {
              default: _withCtx(() => [
                (__props.pcp)
                  ? (_openBlock(), _createBlock(StockDetailsFinance, {
                      key: 0,
                      vehicle: __props.vehicle,
                      "price-matrix": __props.pcp,
                      filters: __props.filters
                    }, null, 8, ["vehicle", "price-matrix", "filters"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_tab_panel, {
              name: "hp",
              class: "q-pa-none"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (__props.hp)
                    ? (_openBlock(), _createBlock(StockDetailsFinance, {
                        key: 0,
                        vehicle: __props.vehicle,
                        "price-matrix": __props.hp,
                        filters: __props.filters
                      }, null, 8, ["vehicle", "price-matrix", "filters"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})